import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { tupperLakeConfig } from "./data";

export default function TupperLakePage() {
  return <CityPageTemplate config={tupperLakeConfig} />;
}